import { Button } from 'antd';
import { FC } from 'react';
import BottomBox from 'components/BottomBox';
import ContributionSuccess from 'modules/Deposit/components/ContributionSuccess';
import style from './style.scss';

interface ContributionProps {
    year: string;
    cost?: number;
    onConfirm?: () => void;
}

const Contribution: FC<ContributionProps> = ({ year, cost, onConfirm }) => {
    return (
        <div className={style.root}>
            <ContributionSuccess year={year} cost={cost} />
            <BottomBox className="btn-box">
                <Button block type="primary" className="btn-important" onClick={onConfirm}>
                    {__('Done')}
                </Button>
            </BottomBox>
        </div>
    );
};

export default Contribution;
